import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {SelectStationsComponent} from "../select-stations/select-stations.component";
import {DateComponent} from "../../date/date.component";
import {ExportResquestForm, OntologyFormType} from 'app/shared/types/form-controls/export-request-form.type';
import {IntervalComponent} from '@gnv-shared/components';
import {OntologyType, PeriodicityType} from '@gnv-shared/models';
import {Subscription} from 'rxjs';
import {TagWriterComponent} from './tag-writer/tag-writer.component';
import {TranslateModule} from '@ngx-translate/core';
import {SelectStationSamplingComponent} from '../select-station-sampling/select-station-sampling.component';
import {SelectStationEnergyComponent} from '../select-station-energy/select-station-energy.component';
import {SelectSubscriptionsComponent} from "../select-subscriptions/select-subscriptions.component";
import {SelectTransactionProviderComponent} from "../select-transaction-provider/select-transaction-provider.component";
import {
  SelectAnalogicCalculationFunctionTypeComponent
} from "../select-analogic-calculation-function-type/select-analogic-calculation-function-type.component";
import {
  SelectAnalogicCalculationIntervalComponent
} from "../select-analogic-calculation-interval/select-analogic-calculation-interval.component";
import {CalculationFunctionType} from 'swagger-gen/web-secured/models/calculation-function-type';
import { DataTimeStepType } from 'swagger-gen/web-secured/models/data-time-step-type';

@Component({
  selector: "app-ontology-writer",
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SelectStationsComponent,
    DateComponent,
    IntervalComponent,
    TagWriterComponent,
    TranslateModule,
    SelectStationSamplingComponent,
    SelectStationEnergyComponent,
    FormsModule,
    SelectSubscriptionsComponent,
    SelectTransactionProviderComponent,
    SelectAnalogicCalculationFunctionTypeComponent,
    SelectAnalogicCalculationIntervalComponent,
  ],
  templateUrl: "./ontology-writer.component.html",
  styleUrls: ["./ontology-writer.component.scss"],
})
export class OntologyWriterComponent implements OnInit, OnDestroy {
  @Input() valueFormGroup!: FormGroup<OntologyFormType>;
  @Input() requestFormGroup!: FormGroup<ExportResquestForm>;

  public periodicityTypes = PeriodicityType;

  public readonly ontologyType  = OntologyType;
  public readonly calculationFunctionType = CalculationFunctionType;

  private sub$!: Subscription;
  private calculationFuncTypeSub$!: Subscription;

  ngOnInit(): void {
    this.sub$ =
      this.requestFormGroup.controls.periodicityType.valueChanges.subscribe(
        (periodicity) => {
          if (periodicity === PeriodicityType.DATE) {
            this.valueFormGroup.controls.dateRanges.controls.startDateTime.addValidators(
              Validators.required
            );
            this.valueFormGroup.controls.dateRanges.controls.endDateTime.addValidators(
              Validators.required
            );

            this.valueFormGroup.controls.interval.removeValidators(
              Validators.required
            );
            this.requestFormGroup.controls.frequency.removeValidators(
              Validators.required
            );

            this.valueFormGroup.controls.interval.reset(null);

          } else {

            this.valueFormGroup.controls.interval.addValidators(
              Validators.required
            );

            this.requestFormGroup.controls.frequency.addValidators(
              Validators.required
            );

            this.valueFormGroup.controls.dateRanges.controls.startDateTime.removeValidators(
              [Validators.required]
            );

            this.valueFormGroup.controls.dateRanges.controls.endDateTime.removeValidators(
              Validators.required
            );

            this.valueFormGroup.controls.dateRanges.reset();
          }
        }
      );

    this.calculationFuncTypeSub$ = this.valueFormGroup.controls.calculationFunctionType.valueChanges
        .subscribe(selectedCalculationFuncType => {
          const dataTimeStepType = this.valueFormGroup.controls.dataTimeStepType;
          const dataTimeStepRange = this.valueFormGroup.controls.dataTimeStepRange;

          if (selectedCalculationFuncType === CalculationFunctionType.RAW) {
            dataTimeStepType.removeValidators(Validators.required);
            dataTimeStepRange.removeValidators(Validators.required);

            dataTimeStepType.reset(null);
            dataTimeStepRange.reset(null);
          } else {
            dataTimeStepType.addValidators(Validators.required);
            dataTimeStepRange.addValidators(Validators.required);

            dataTimeStepType.setValue(DataTimeStepType.MINUTE);
            dataTimeStepRange.setValue(1);
          }

          dataTimeStepType.updateValueAndValidity();
          dataTimeStepRange.updateValueAndValidity();
        });

  }

  ngOnDestroy(): void {
    this.sub$?.unsubscribe();
    this.calculationFuncTypeSub$?.unsubscribe();
  }
}
